import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBottle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBottle"><Path d="M8.625 1V2.5H9.25V6.92163L6 9.92163V23H18V9.92163L14.75 6.92163V2.5H15.375V1H8.625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBottle;
